/* eslint-disable */
const mutations = {
  updateIsLoading(state, { isLoading }) {
    state.isLoading = isLoading;
  },

  setGroup(state, { group }) {
    state.data = group;
  },

  updateGroup(state, { group }) {
    state.data = {
      ...state.data,
      ...group,
    };
  },
};

export default mutations;
